import React from "react";
import { Col, Empty, Row } from "antd";
import ContentBlocker from "../../components/contentBlocker/contentBlocker";

export function ListItems(props) {

  return (
    <Row gutter={[16, 16]}>
        {
            (props.items.length !== 0) ? (
                <ContentBlocker
                    content={props.items}
                    typeContent={"prideTalks"}
                    handleClick={props.handleLinkConference}
                    title={"¿Quieres ver más videopodcast?"}
                />
            ) : (
                <Col xs={24}>
                    <Empty description={"No hay eventos disponibles"} />
                </Col>
            )
        }
    </Row>
  );
}
